import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { httpResetPassword } from '@/features/auth/http/auth.http'
import { MUTATION_KEYS } from '@/query-client'
import type { ErrorResponseData } from '@/types/commons.ts'

interface useResetPasswordProps {
	onSuccess?: () => void
	onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useResetPassword = (options?: useResetPasswordProps) => {
	return useMutation({
		mutationKey: [MUTATION_KEYS.RESET_PASSWORD],
		mutationFn: (params: { email: string }) => httpResetPassword(params),
		onError: (error: AxiosError<ErrorResponseData>) =>
			options?.onError?.(error),
		onSuccess: () => options?.onSuccess?.()
	})
}
